<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        NLP Topics
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>NLP TOPIC Mappings</li>
        <li class="active">Topic List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Topic List (Edit the topic to configure Label-Conversation Mapping)</h3>
              <div class="action-button pull-right">  
                <button type="button" class="btn btn-primary" @click="OpenPOP()">Add Topic</button>
              </div>
              <div class="modal-backdrop" v-if="showModal" id="Modal">
                <div class="modal modal-md" style="height: 400PX;max-width:600px">
                  <header class="modal-header">
                    <slot name="header">
                      <h3>Enter Topic</h3>
                    </slot>
                    <div class="modal-body">
                      <slot name="body">
                      <form class="form-horizontal" @submit.prevent="addNewMapping" action="#" method="post">
                        <div class="form-group">
                          <label for="campaign" style="font-weight:500" class="col-sm-4 control-label required">Topic Name</label>
                    
                          <div class="col-sm-8">
                          <input type="text" v-model="topic_name" 
                            v-bind:class="{'form-group--error': submitted && !$v.topic_name.required }"
                            class="form-control" id="name" placeholder="New Topic Name" />
                            <span v-if="submitted && !$v.topic_name.required" class="text-red pull-left">Please enter topic name.</span>
                          </div>

                        </div>
                        <div class="form-group">
                          <label for="promptId" style="font-weight:500" class="col-sm-4 control-label required">Prompt</label>
                          <div class="col-sm-8">
                            <nv-select 
                              class="form-control" 
                              v-bind:class="{'form-group--error': submitted && !$v.promptId.required }"
                              id="promptId" 
                              v-model="promptId">
                              <option value="">--Select a prompt--</option>
                              <option v-for="prompt in promptList" 
                                :key="prompt.id" 
                                :value="prompt.id">
                                {{prompt.prompt_name}}
                              </option>
                            </nv-select>
                            <span v-if="submitted && !$v.promptId.required" class="text-red pull-left">Please select a prompt.</span>
                          </div>
                        </div>
                        <div class="form-group pull-right">
                          <div class="col-sm-12">
                            <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                            <input type="submit" class="btn btn-primary" value="Submit">
                          </div>
                        </div>
                      </form>
                      </slot>
                    </div>
                  </header>
                  <footer class="modal-footer"></footer>
                </div>
              </div>
            </div>
              <!-- /.box-header -->
            <div class="loader" v-if="actionInProgress">
              <img src="/static/assets/loader/nivi-loader.svg" />
            </div>

            <div class="box-footer no-border">
              <div class="row">
                <div class="col-md-12">
                  <vue-good-table
                    mode="remote"
                    styleClass="vgt-table good-table condensed striped"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :columns="columns"
                    :rows="mappingData"
                    :totalRows="mappingCount"
                     :pagination-options="{
                        enabled: true,
                        perPage: 20
                    }">
                    <div slot="emptystate"><nv-empty-state icon="fa-list" title="No topic mappings found" hint="Try changing the filters." /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />

                        <span v-if="props.column.field == 'created_at'">
                          {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="props.column.field == 'edit'">
                          <router-link :to="`nlp_topic_detail?topicId=${props.row.id}&&topic_name=${props.row.topic}&&promptId=${props.row.prompt_id}`">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else-if="props.column.field == 'delete'">
                          <i class="fa fa-times-circle" aria-hidden="true" v-on:click="showDeleteConfirmationPopup(props.index)"></i>
                        </span>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        
                      </template>    
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>       
    </section>
    
      <deleteConfirmationModal
        v-if="isDeleteConfirmationVisible"        
        @close="closeConfirmationModal" 
        @deleteNlpTopicMapping="deleteNlpTopicMapping"
        :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
        :confirmationMessage="confirmationMessage" 
        :actionToBePerformed="actionToBePerformed"
        />

    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import flatPickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
import api from '../../../utils/api'
import deleteConfirmationModal from './../popup/deleteConfirmation'
import { formatDate, getSelectorValue } from '../../../utils/utilities'

export default {
  name: 'nlpTopicMappingList',
  components: {
    'deleteConfirmationModal': deleteConfirmationModal,
    flatPickr
  },
  validations: {
    topic_name: {
      required
    },
    promptId: {
      required
    }
  },
  mounted () {
    this.getAllNlpTopicMappingFromDB()
    this.getAllPrompts()
    flatPickr('input[placeholder="Select Date Range', {
      dateFormat: 'd-m-Y',
      mode: 'range',
      allowInput: true
    })
  },
  data () {
    return {
      formatDate: formatDate,
      loading: true,
      actionInProgress: false,
      isModalVisible: false,
      isDeleteConfirmationVisible: false,
      conversationList: [],
      mappingData: [],
      mappingCount: 0,
      clonedmappingData: [],
      actionToBePerformed: 'Add Nlp Topic mapping',
      confirmationMessage: 'Are you sure you want to delete this Nlp Topic mapping?',
      rowIndexToBeUpdated: 0,
      tableQueryParams: {
        columnFilters: {is_deleted: false},
        sort: {
          created_at: -1
        },
        page: 1,
        perPage: 20
      },
      columns: [
        {
          label: 'Topic',
          field: 'topic',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Topic'
          }
        },
        {
          label: 'Prompt',
          field: 'prompt_name',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Prompt'
          }
        },
        {
          label: 'Created On',
          field: 'created_at',
          sortable: true,
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range'
          }
        },
        {
          label: 'Edit',
          field: 'edit',
          sortable: false
        },
        {
          label: 'Delete',
          field: 'delete',
          sortable: false
        }
      ],
      previousQueryParams: {},
      showModal: false,
      topic_name: '',
      promptList: [],
      promptId: '',
      submitted: false
    }
  },
  methods: {
    OpenPOP () {
      this.showModal = true
    },
    close () {
      this.showModal = false
      this.topic_name = ''
      this.promptId = ''
      this.submitted = false
    },
    addNewMapping () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid || (this.promptId === null || this.topic_name.trim() === '')) {
        return
      }
      this.loading = true

      api.buildRequest('addNlpTopic', 'POST', { topic: this.topic_name.trim(), prompt_id: this.promptId })
        .then(response => {
          this.actionInProgress = false
          console.log('response ', response)
          if (response.status === 200) {
            this.$router.push({ name: 'nlp_topic_detail', query: { topicId: response.data.payload.message.data.id, topic_name: this.topic_name, promptId: this.promptId } })
          } else if (response.status === 403) {
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
            this.showModal = true
            this.loading = false
          } else {
            console.log('something went wrong')
          }
        }).catch(({ response }) => {
          this.actionInProgress = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
    },
    updateParams (newProps) {
      this.tableQueryParams = {...this.tableQueryParams, ...newProps}
    },
    onPageChange (params) {
      this.updateParams({page: params.currentPage})
      this.getAllNlpTopicMappingFromDB()
    },
    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage})
      this.getAllNlpTopicMappingFromDB()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          [this.columns[params.columnIndex].field]: params.sortType === 'asc' ? 1 : -1
        }
      })
      this.getAllNlpTopicMappingFromDB()
    },
    onColumnFilter (params) {
      let appliedFilter = {}
      for (const key in params.columnFilters) {
        if (key === 'created_at') {
          const filterDates = params.columnFilters[key].split(' to ')
          if (filterDates.length && filterDates[0]) {
            appliedFilter['createdFromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
            appliedFilter['createdToDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
          }
        } else if (params.columnFilters[key]) {
          appliedFilter[key] = params.columnFilters[key]
        }
      }
      this.updateParams({columnFilters: appliedFilter})
      this.getAllNlpTopicMappingFromDB()
    },
    closeConfirmationModal () {
      this.isDeleteConfirmationVisible = false
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Nlp Topic mapping'
      }, 500)
    },
    closeModal () {
      this.rowIndexToBeUpdated = 0
      this.isModalVisible = false
      this.isDeleteConfirmationVisible = false
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Nlp Topic mapping'
      }, 500)
    },
    showDeleteConfirmationPopup (index) {
      this.actionToBePerformed = 'Delete Nlp Topic mapping'
      this.confirmationMessage = 'This deletes the mapping of all labels for this topic. Are you sure you want to delete this Nlp Topic mapping?'
      this.isDeleteConfirmationVisible = true
      this.rowIndexToBeUpdated = index
    },
    getAllPrompts () {
      api.buildRequest('getAllPrompts', 'POST', {})
        .then(response => {
          if (response.status === 200) {
            this.promptList = response.data.payload.prompts
          } else {
            console.log('something went wrong')
          }
        }).catch(({ response }) => {
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
    },
    getAllNlpTopicMappingFromDB (isdeleted = false) {
      this.loading = true

      let queryParams = {
        skip: this.tableQueryParams.perPage * (this.tableQueryParams.page - 1),
        limit: this.tableQueryParams.perPage,
        sort: this.tableQueryParams.sort,
        selector: getSelectorValue(this.tableQueryParams.columnFilters)
      }

      if (!isdeleted && JSON.stringify(this.previousQueryParams) === JSON.stringify(queryParams)) {
        this.loading = false
        return
      } else if (JSON.stringify(this.previousQueryParams.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParams.sort) !== JSON.stringify(queryParams.sort)) {
        queryParams.skip = 0
        this.tableQueryParams.page = 1
      }

      api.buildRequest('getNlpTopicMappingList', 'POST', queryParams)
      .then(response => {
        this.loading = false
        if (response.status === 200) {
          this.previousQueryParams = queryParams
          if (response.data.payload.mappings.length > 0) {
            this.mappingData = response.data.payload.mappings
            this.clonedmappingData = this.mappingData
            this.mappingCount = response.data.payload.mappingCount
          } else {
            this.mappingData = []
            this.clonedmappingData = this.mappingData
          }
        } else {
          console.log('something went wrong')
        }
      }).catch(({ response }) => {
        this.loading = false
        this.$swal({
          type: 'error',
          text: response ? response.data.payload.message : 'An error occurred'
        })
      })
    },
    deleteNlpTopicMapping () {
      this.loading = true
      const deletedRow = this.mappingData[this.rowIndexToBeUpdated]
      var self = this
      api.buildRequest('deleteNlpTopicMapping', 'POST', { topic_id: deletedRow.id })
      .then(response => {
        self.loading = false
        self.rowIndexToBeUpdated = 0
        self.closeModal()
        if (response.status === 200) {
          self.isDeleteConfirmationVisible = false
          this.$swal({
            type: 'success',
            text: response ? response.data.payload.message : 'Nlp Topic mapping deleted successfully'
          }).then(() => {
            this.getAllNlpTopicMappingFromDB(true)
          })
        } else {
          console.log('something went wrong')
        }
      }).catch(({ response }) => {
        self.closeModal()
        self.rowIndexToBeUpdated = 0
        self.isDeleteConfirmationVisible = false
        self.loading = true
        this.$swal({
          type: 'error',
          text: response ? response.data.payload.message : 'An error occurred'
        })
      })
    }
  }
}
</script>
<style>
.vgt-inner-wrap.is-loading {
  opacity: 1 !important;
  pointer-events: auto !important;
}
.mrgn-right-20px {
  margin-right: 20px;
}
.good-table td {
  white-space: normal;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
</style>


// WEBPACK FOOTER //
// nlpTopicMappingList.vue?4a348a98